import { render, staticRenderFns } from "./DeliveryVehiclesManager.vue?vue&type=template&id=1a2fbbdd&scoped=true&"
import script from "./DeliveryVehiclesManager.vue?vue&type=script&lang=ts&"
export * from "./DeliveryVehiclesManager.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryVehiclesManager.vue?vue&type=style&index=0&id=1a2fbbdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2fbbdd",
  null
  
)

export default component.exports